(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('RcopiaInstructionSearch', RcopiaInstructionSearch);

    RcopiaInstructionSearch.$inject = ['$resource'];

    function RcopiaInstructionSearch($resource) {
        var resourceUrl =  'api/_search/rcopia-instructions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
